export interface Article {
  id: string;
  title: string;
  slug: string;
  category: string;
  thumbnail: string;
  excerpt: string;
  content: string;
  author: string;
  publishDate: string;
  tags: string[];
  views: number;
}

export const articles: Article[] = [
  {
    id: 'a001',
    title: '2025年暑期档最值得期待的十部电视剧',
    slug: '2025-shuqidang-qidai',
    category: 'reboju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Summer%20evening%20outdoor%20cinema%20screen%20with%20colorful%20lights%20and%20audience%20silhouettes%2C%20warm%20sunset%20sky%2C%20entertainment%20festival%20atmosphere%2C%20magical%20mood%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=450&seq=article-summer&orientation=landscape',
    excerpt: '暑期档向来是各大平台必争之地。2025年的暑期档更是好剧扎堆，从古装大剧到现代都市，从悬疑探案到科幻冒险，总有一部适合你。',
    content: `<h2>2025年暑期档最值得期待的十部电视剧</h2><p>暑期档向来是各大平台必争之地。2025年的暑期档更是好剧扎堆，从古装大剧到现代都市，从悬疑探案到科幻冒险，总有一部适合你。</p><h3>1. 《庆余年》第二季</h3><p>范闲归来！这部备受期待的续集终于来了。张若昀、李沁等原班人马回归，陈道明、吴刚等老戏骨继续加盟。第一季留下了太多悬念，第二季将逐一揭晓。</p><h3>2. 《大奉打更人》</h3><p>改编自卖报小郎君同名小说，王鹤棣、田曦薇主演的奇幻古装剧，讲述现代打工人穿越到大奉王朝的奇妙冒险。</p><h3>3. 《与凤行》</h3><p>赵丽颖、林更新再度合作，仙侠大剧备受瞩目。精美的特效和宏大的世界观构建，让这部剧在播出前就收获了极高期待。</p>`,
    author: '追剧小助手',
    publishDate: '2025-06-15',
    tags: ['暑期档', '热播剧', '推荐', '电视剧'],
    views: 156000,
  },
  {
    id: 'a002',
    title: '豆瓣9分以上国产剧推荐：这些神作值得N刷',
    slug: 'douban-9fen-guocanju',
    category: 'reboju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cozy%20home%20living%20room%20with%20large%20TV%20screen%20showing%20drama%20scene%2C%20warm%20ambient%20lighting%2C%20comfortable%20sofa%20with%20blanket%2C%20evening%20vibe%2C%20editorial%20home%20entertainment%20photography%2C%20clean%20composition&width=800&height=450&seq=article-douban&orientation=landscape',
    excerpt: '豆瓣评分是很多观众选剧的重要参考。能达到9分以上的国产剧，无一不是精品中的精品。来看看这些值得反复观看的神作。',
    content: `<h2>豆瓣9分以上国产剧推荐</h2><p>豆瓣评分是很多观众选剧的重要参考。能达到9分以上的国产剧，无一不是精品中的精品。来看看这些值得反复观看的神作。</p><h3>《大明王朝1566》- 9.8分</h3><p>被誉为中国电视剧的巅峰之作。陈宝国、倪大红等实力派演员的精彩演绎，加上深刻的剧本，让这部剧成为无法超越的经典。</p><h3>《走向共和》- 9.7分</h3><p>一部全景式展现中国近代史的电视剧，从慈禧到孙中山，人物群像刻画入木三分。</p><h3>《红楼梦》1987版 - 9.7分</h3><p>公认的《红楼梦》最佳影视改编。欧阳奋强、陈晓旭的表演深入人心，成为一代人的集体记忆。</p>`,
    author: '追剧小助手',
    publishDate: '2025-05-20',
    tags: ['豆瓣', '国产剧', '高分', '推荐'],
    views: 203000,
  },
  {
    id: 'a003',
    title: '《繁花》爆火背后：王家卫的电视剧美学革命',
    slug: 'fanhua-wangjiawei-meixue',
    category: 'reboju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Art%20deco%20Shanghai%20street%20scene%20in%20golden%20hour%20light%20with%20vintage%20cars%20and%20neon%20signs%2C%20nostalgic%201990s%20Chinese%20city%20aesthetic%2C%20cinematic%20warm%20tones%2C%20elegant%20editorial%20photography%2C%20clean%20composition&width=800&height=450&seq=article-fanhua&orientation=landscape',
    excerpt: '《繁花》不仅是一部电视剧，更是一场视觉盛宴。王家卫用他标志性的影像风格，重新定义了国产剧的审美天花板。',
    content: `<h2>《繁花》爆火背后：王家卫的电视剧美学革命</h2><p>《繁花》不仅是一部电视剧，更是一场视觉盛宴。王家卫用他标志性的影像风格，重新定义了国产剧的审美天花板。</p><h3>光影的诗意</h3><p>王家卫在《繁花》中大量运用了金色和琥珀色调，营造出浓郁的复古上海风情。每一帧画面都像是一幅精心构图的摄影作品。</p><h3>节奏的韵律</h3><p>与大多数国产剧的快节奏不同，《繁花》有着独特的叙事节奏，留白和沉默成为表达的重要手段。</p><h3>演员的蜕变</h3><p>胡歌在剧中的表演被很多观众称为"最好的胡歌"，马伊琍、唐嫣、辛芷蕾也都贡献了从影以来的最佳演技之一。</p>`,
    author: '影视评论员',
    publishDate: '2025-04-10',
    tags: ['繁花', '王家卫', '美学', '影评'],
    views: 189000,
  },
  {
    id: 'a004',
    title: '2025年奥斯卡最佳影片提名名单深度解析',
    slug: '2025-aosika-timing',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Hollywood%20award%20ceremony%20stage%20with%20golden%20statue%20and%20red%20curtain%2C%20glamorous%20atmosphere%2C%20spotlights%2C%20cinematic%20event%20photography%2C%20elegant%20and%20prestigious%20mood%2C%20clean%20composition&width=800&height=450&seq=article-oscar&orientation=landscape',
    excerpt: '一年一度的奥斯卡颁奖典礼即将到来。今年的提名名单呈现出前所未有的多元化趋势，多部亚洲电影入围重要奖项。',
    content: `<h2>2025年奥斯卡最佳影片提名名单深度解析</h2><p>一年一度的奥斯卡颁奖典礼即将到来。今年的提名名单呈现出前所未有的多元化趋势，多部亚洲电影入围重要奖项。</p><h3>亚洲力量的崛起</h3><p>继《寄生虫》之后，今年又有多部亚洲电影入围最佳影片提名，这标志着好莱坞对亚洲电影的认可达到了新高度。</p><h3>流媒体与传统影院的博弈</h3><p>今年的提名名单中，流媒体平台出品的电影占据了半壁江山，Netflix和Apple TV+成为最大赢家。</p>`,
    author: '电影观察家',
    publishDate: '2025-03-01',
    tags: ['奥斯卡', '电影', '颁奖', '影评'],
    views: 125000,
  },
  {
    id: 'a005',
    title: '新海诚新作《铃芽之旅》续篇确认制作',
    slug: 'xinhaicheng-xupian',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20beautiful%20sky%20with%20dramatic%20clouds%20and%20sunlight%20rays%2C%20dreamy%20atmosphere%2C%20Makoto%20Shinkai%20aesthetic%2C%20emotional%20and%20poetic%20mood%2C%20anime%20art%20style%2C%20clean%20composition&width=800&height=450&seq=article-shinkai&orientation=landscape',
    excerpt: '新海诚导演在最新采访中透露，他的下一部作品已经开始前期制作，预计2026年上映。粉丝们已经开始期待这部新作了。',
    content: `<h2>新海诚新作《铃芽之旅》续篇确认制作</h2><p>新海诚导演在最新采访中透露，他的下一部作品已经开始前期制作，预计2026年上映。粉丝们已经开始期待这部新作了。</p><h3>新作的主题</h3><p>据透露，新作将继续探讨"连接"这一主题，但故事背景将设定在一个全新的世界观中。</p><h3>制作团队</h3><p>核心制作团队保持不变，RADWIMPS将继续负责音乐制作。这将是新海诚继《你的名字。》《天气之子》《铃芽之旅》之后的第四部原创长片。</p>`,
    author: '动漫资讯站',
    publishDate: '2025-07-01',
    tags: ['新海诚', '铃芽之旅', '动漫', '新作'],
    views: 98000,
  },
];